import { render } from "./TestimonialCarousel.vue?vue&type=template&id=63bce410&scoped=true"
import script from "./TestimonialCarousel.vue?vue&type=script&lang=js"
export * from "./TestimonialCarousel.vue?vue&type=script&lang=js"

import "./TestimonialCarousel.vue?vue&type=style&index=0&id=63bce410&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63bce410"]])

export default __exports__